import { CANONICAL_HOSTS } from "@/engine/support/siteHost";

export const LOVABLE_PREVIEW_ZONES = [
  "lovableproject.com",
  "lovableproject-dev.com",
  "lovable.app",
  "gpt-eng.com",
  "gptengineer.run",
] as const;

export type DeploymentEnvironment =
  "development" | "lovable-preview" | "production";

// Redirect aliases are production traffic even though only the canonical host
// renders the application.
const PRODUCTION_HOSTS = new Set<string>([
  "app.syncani.com",
  "syncani.lovable.app",
  "room.syncani.com",
  "www.syncani.com",
  ...CANONICAL_HOSTS,
]);

export function isLovablePreviewHost(hostname: string): boolean {
  const host = hostname.toLowerCase();
  if (PRODUCTION_HOSTS.has(host)) return false;
  return LOVABLE_PREVIEW_ZONES.some(
    (zone) => host === zone || host.endsWith(`.${zone}`),
  );
}

export function deploymentEnvironment(
  isDevBuild: boolean,
  hostname: string,
): DeploymentEnvironment {
  if (isDevBuild) return "development";
  return PRODUCTION_HOSTS.has(hostname.toLowerCase())
    ? "production"
    : "lovable-preview";
}
